import { PlusOutlined } from '@ant-design/icons'
import { FloatButton, Image, Typography } from 'antd'
import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { thousandSeparator } from '../../../utils/numberManager'
import { AddButton, AddListWrapper, ImgWrapper, ItemWrapper, ListHeader, ListWrapper, Wrapper } from './styles'

import dayjs from 'dayjs'
import expense from "../../../assets/icons/expense.png"
import gear from "../../../assets/icons/gear.png"
import mechanic from "../../../assets/icons/mechanic.png"
import { financeCategoryList, financeIcon } from '../../../constants/finance'
import { useFinances } from '../../../zustand/store'

const list = [
    {
        id: 1,
        name: "Light",
        year: 2020,
        expense: 1560,
        // img: tools,
        category: "mechanic"
    },
    {
        id: 2,
        name: "Gear",
        year: 2017,
        expense: 320,
        // img: gear,
        category: "part"
    },
    {
        id: 3,
        name: "Wash",
        year: 2017,
        expense: 320,
        // img: expense,
        // category: "part"
    }
]

export const carList = list;

const expenseImg = {
    part: gear,
    //   repairer: "linear-gradient( 135deg, #E2B0FF 10%, #9F44D3 100%)",
    mechanic,
    default: expense,
};

const Img = ({ src, category }) => {
    return (
        <ImgWrapper category={category}>
            {src ? <Image src={src} alt="images" /> : <img src={expenseImg[category] || expenseImg.default} alt={category} />}
        </ImgWrapper>
    )
}

const ExpenseItem = ({
    // name, year, expense, img, category, id: eId 
    addedAt, carId, category, color
    , createdAt,
    debt,
    id: eId,
    image,
    imageId,
    images,
    name,
    note,
    price,
    thumbnailId,
    type,
    updatedAt

}) => {
    const navigate = useNavigate();
    const { id } = useParams();
    return <ItemWrapper onClick={() => {
        navigate(`/car/${id}/expense/${eId}`)
    }} >
        <Img
            src={financeIcon(category) || financeIcon("Other")}
            category={
                category
            }
        />
        <div className='data'>
            <div>
                <Typography.Text strong>
                    {category === "Sold" ? "Sold Out" : category}
                </Typography.Text>
            </div>
            <div>
                <Typography.Text>{note}

                </Typography.Text>
            </div>
            {/* <div>
                <Typography.Text type="secondary">{year}</Typography.Text>
            </div> */}
        </div>
        <div className='rightside'>
            {/* <div className='expense'> */}
            {type === "expense" ?
                <Typography.Text small style={{ textAlign: "right" }} strong align="right"
                    type='danger'
                >

                    -${thousandSeparator(price)}
                </Typography.Text>

                :
                type === "income" ?
                    <Typography.Text small style={{ textAlign: "right" }} strong align="right"
                        type='success'
                    >

                        ${thousandSeparator(price)}
                    </Typography.Text> : <Typography.Text small style={{ textAlign: "right" }} strong align="right"
                    >

                        ${thousandSeparator(price)}
                    </Typography.Text>
            }
            <Typography.Text type="secondary">
                <small>
                    {dayjs(addedAt).format("DD/MM/YYYY")}
                </small>
            </Typography.Text>
            {/* </div> */}
        </div>
    </ItemWrapper>
}

function ExpenseList() {
    const navigate = useNavigate();
    const { id } = useParams();
    const finances = useFinances();

    useEffect(() => {
        finances.execute({ params: { carId: id }, force: true })
    }, [])

    const total = finances?.data?.reduce((t, v, i) => ({
        ...t,
        [v.category]: {
            ...t[v.category],
            [v.type]: (t?.[v.category]?.[v.type] || 0) + (v?.price || 0)
        }

    }), {})


    return (
        <Wrapper>
            <ListWrapper>
                <ListHeader>
                    {/* <div> */}
                    <Typography.Title style={{ margin: 0 }} level={4}>
                        Expenses
                    </Typography.Title>
                    {/* </div>
                    <div> */}
                    {/* <Button type='primary'>
                        Add
                    </Button> */}
                    {/* </div> */}
                </ListHeader>
                <AddListWrapper>
                    {
                        // [{ img: gear }, { img: mechanic }, { img: expense }]
                        financeCategoryList
                            // finances?.data
                            ?.map(({ img: src, name }) => (
                                <AddButton onClick={() => {
                                    navigate(`/car/${id}/expense/new?c=${name}`)
                                }}>
                                    <div style={{ position: "relative" }}>
                                        <div style={{
                                            position: "absolute",
                                            top: "-3px", right: "-3px",
                                            backgroundColor: "white",
                                            border: "1px solid black",
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            // fontSize: "15px",
                                            // lineHeight: "15px",
                                            padding: "0px"

                                        }}>
                                            +
                                        </div>
                                        <img src={src} alt="" />
                                    </div>
                                    <div className='price'>
                                        {total?.[name]?.income && <div>
                                            <Typography.Text strong type='success'>
                                                ${thousandSeparator(total?.[name]?.income || 0)}
                                            </Typography.Text>
                                        </div>}
                                        <div>
                                            <Typography.Text strong type='danger'>
                                                -${thousandSeparator(total?.[name]?.expense || 0)}
                                            </Typography.Text>
                                        </div>
                                    </div>

                                </AddButton>
                            ))
                    }
                </AddListWrapper>
                {
                    // list
                    finances.data
                        ?.map((data) => (
                            <ExpenseItem {...data} />
                        ))}
            </ListWrapper>
            <FloatButton onClick={() => {
                navigate(`/car/${id}/expense/new`)
            }} type='primary'
                // size={"large"} 
                icon={<PlusOutlined />} />
        </Wrapper>
    )
}

export default ExpenseList